module.exports = __webpack_public_path__ + "images/emoji/fried_shrimp.9edf4cf63607e9a8cfa6.png";